import type { ImageProps } from 'next/legacy/image';
import NextImage from 'next/legacy/image';

/**
 * 이미지 리사이즈 쿼리(`?q=&t=contain&w=`)를 붙여 요청하는 next/legacy/image 래퍼.
 *
 * Pages Router 의 `~/components/Image` 의 `ShoebillImage` 를 App Router 로 이관한 것이다.
 * App Router(`src/app`) 영역에서는 `ShoebillImage` 대신 이 컴포넌트를 사용한다.
 */
const resizeImageLoader: ImageProps['loader'] = ({ src, quality, width }) => {
  return `${src}?q=${quality || 75}&t=contain&w=${width}`;
};

export function ResizeNextImage({
  width = 768,
  height = 768,
  ...props
}: ImageProps) {
  // eslint-disable-next-line jsx-a11y/alt-text
  return (
    <NextImage
      width={width}
      height={height}
      {...props}
      loader={resizeImageLoader}
    />
  );
}
